ExclusiveImageVue(v-if='media.type === \'IMAGE\'' :url='media.url')
video(v-else controls)
  source(:src='media.url' type='video/mp4')
